import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import Button from 'kingpin/atoms/Button';
import React from 'react';

const FormHeaderDiv = styled.div`
  margin-bottom: 16px;
  border-bottom: 1px solid var(--color-border-secondary);
  padding-bottom: 12px;
`;

const FormHeaderTopRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 16px;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

const FormHeader = ({
  title,
  titleExtra,
  subTitle,
  onClose,
}: {
  title: string;
  titleExtra?: JSX.Element;
  subTitle?: string;
  onClose?: () => void;
}) => {
  return (
    <FormHeaderDiv>
      <FormHeaderTopRow>
        <TitleRow>
          <Typography.Header type={'H4'}>{title}</Typography.Header>
          {titleExtra ? <>{titleExtra}</> : null}
        </TitleRow>
        {onClose ? (
          <Button
            size={'Small'}
            type={'Secondary'}
            icon="cross"
            onClick={onClose}
            testId="close"
          />
        ) : (
          <div />
        )}
      </FormHeaderTopRow>
      {subTitle && (
        <Typography.Body type={'Body 13'} color="var(--color-icon-secondary)">
          {subTitle}
        </Typography.Body>
      )}
    </FormHeaderDiv>
  );
};

export default FormHeader;
